/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-07-15 15:09:09
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbShopLabelTemplate {
    /**我的模版 */
    export var GetShopLabelTemplateList = (body): Promise<any> => {
        return Post(`/api/TbShopLabelTemplate/GetShopLabelTemplateList`, body);
    };
    /**获取我的模板详情 */
    export var GetTbShopLabelTemplateById = (body): Promise<any> => {
        return Get(`/api/TbShopLabelTemplate/GetTbShopLabelTemplateById`, body);
    };
    /**修改我的模版 */
    export var PutTbShopLabelTemplate = (body): Promise<any> => {
        return Put(`/api/TbShopLabelTemplate/PutTbShopLabelTemplate`, body);
    };
   
}



// WEBPACK FOOTER //
// ./src/http/api_TbShopLabelTemplate.ts